(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .filter('percent', percentFactory);

    percentFactory.$inject = ['$filter'];
    function percentFactory($filter) {
        return function percent(number, fractionSize) {
            return $filter('number')(number * 100, fractionSize || 0) + '%';
        }
    }
})();